/* eslint-disable @typescript-eslint/no-explicit-any */
const fedopsLogger = require('@wix/fedops-logger');

let loggerInstance: any;

export const FEDOPS_TESTKIT_URL = 'localhost:13333';

export const clearInstance = () => (loggerInstance = undefined);

export const getInstance = () => {
  if (!loggerInstance) {
    initialize();
  }

  return loggerInstance;
};

const getInitOptions = (testMode = false) => {
  return testMode ? { baseUrl: FEDOPS_TESTKIT_URL } : {};
};

const initialize = () => {
  if (!window.__FEDOPS_APP_NAME__ || typeof window.__FEDOPS_TEST_MODE__ === 'undefined') {
    throw new Error('Missing global variables for FEDOPS initialization!');
  }

  loggerInstance = fedopsLogger.create(window.__FEDOPS_APP_NAME__, getInitOptions(window.__FEDOPS_TEST_MODE__));

  delete window.__FEDOPS_APP_NAME__;
  delete window.__FEDOPS_TEST_MODE__;
};
